<template>
  <ChecklistBlockBase
    :buttonsPreset="'edit'"
    @edit="startUpload"
    :buttonsData="editorMetadata.buttonsData"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <img
      class="media-image"
      :class="{ busy }"
      :src="block.media_file.url || '/img/image-placeholder.png'"
      v-if="block.media_file.url && isImageBasedType"
    />
    <video
      class="media-image"
      controls
      :src="block.media_file.url"
      v-if="block.media_file.url && isVideoBasedType"
    />

    <PresignedFileUploader
      @cancel="onUploadCancelled"
      @startedUpload="busy = true"
      @uploaded="onUploaded"
      resourceType="checklist_assets"
      ref="uploader"
    />
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";

import PresignedFileUploader from "@/components/PresignedFileUploader.vue";

export default {
  props: {
    block: Object,
    editorMetadata: Object,
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    startUpload() {
      if (this.busy) return;
      this.$refs.uploader.showUploadDialog();
    },
    onUploadCancelled() {
      if (!this.block.media_file.url) this.$emit("commonAction", "delete");
    },
    onUploaded(url, metadata) {
      this.$set(this.block, "media_file", {
        url,
        type: metadata.type,
      });
      this.busy = false;
    },
  },
  mounted() {
    if (!this.block.media_file.url) {
      this.startUpload();
    }
  },
  computed: {
    isImageBasedType() {
      return ["image/png", "image/jpeg", "image/svg+xml", "image/gif"].includes(
        this.block.media_file.type
      );
    },
    isVideoBasedType() {
      return [
        "video/webm",
        "video/ogg",
        "video/mp4",
        "video/x-msvideo",
        "video/mpeg",
        "video/3gpp",
        "video/mov",
        'video/x-m4v',
        'video/quicktime'
      ].includes(this.block.media_file.type);
    },
  },
  components: {
    ChecklistBlockBase,
    PresignedFileUploader,
  },
};
</script>

<style scoped>
.media-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
}

.busy {
  opacity: 0.8;
}
</style>